// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

import Layout from '@/layout';
var sjtAndminRouter = {
  path: '/sjtAndmin',
  component: Layout,
  redirect: '/sjtAndmin/list',
  name: 'sjtAndmin',
  alwaysShow: true,
  meta: {
    title: '三甲通管理',
    icon: 'clipboard'
  },
  children: [{
    path: 'list',
    name: "list",
    meta: {
      title: '服务申请列表'
    },
    component: function component() {
      return import('@/views/sjtAndmin/list/index');
    }
  }, {
    path: 'active',
    name: "active",
    meta: {
      title: '套餐列表'
    },
    component: function component() {
      return import('@/views/sjtAndmin/active/index');
    }
  }]
};
export default sjtAndminRouter;